(() => {
  const root = window.Shopify?.routes?.root || '/';
  const money = (cents) => {
    const value = Number(cents || 0) / 100;
    return `R${Number.isInteger(value) ? value.toFixed(0) : value.toFixed(2)}`;
  };
  const escapeHtml = (value = '') => String(value)
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#039;');

  const drawer = document.querySelector('#CartDrawer');
  const cartItems = drawer?.querySelector('[data-cart-items]');
  const cartFooter = drawer?.querySelector('[data-cart-footer]');

  function openCart() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cart-is-open');
    document.querySelectorAll('[data-cart-open]').forEach((button) => button.setAttribute('aria-expanded', 'true'));
    drawer.querySelector('[data-cart-close]')?.focus();
    refreshCart();
  }

  function closeCart() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cart-is-open');
    document.querySelectorAll('[data-cart-open]').forEach((button) => button.setAttribute('aria-expanded', 'false'));
  }

  function renderCart(cart) {
    document.querySelectorAll('[data-cart-count]').forEach((node) => { node.textContent = cart.item_count; });
    if (!cartItems || !cartFooter) return;

    if (!cart.item_count) {
      cartItems.innerHTML = '<div class="cart-empty"><div class="cart-empty__icon">🛍️</div><h3>Your cart is waiting</h3><p>Choose a HEYXI bundle to begin your softer-heels routine.</p></div>';
      cartFooter.hidden = true;
    } else {
      cartItems.innerHTML = cart.items.map((item) => `
        <article class="drawer-line">
          ${item.image ? `<img src="${escapeHtml(item.image)}&width=180" alt="${escapeHtml(item.product_title)}" width="180" height="180">` : '<div></div>'}
          <div class="drawer-line__copy">
            <strong>${escapeHtml(item.product_title)}</strong>
            ${item.variant_title && item.variant_title !== 'Default Title' ? `<small>${escapeHtml(item.variant_title)}</small>` : ''}
            <div class="drawer-line__qty">
              <button type="button" data-cart-change="${escapeHtml(item.key)}" data-quantity="${Math.max(0, item.quantity - 1)}" aria-label="Decrease quantity">−</button>
              <span>${item.quantity}</span>
              <button type="button" data-cart-change="${escapeHtml(item.key)}" data-quantity="${item.quantity + 1}" aria-label="Increase quantity">+</button>
            </div>
          </div>
          <strong class="drawer-line__price">${money(item.final_line_price)}</strong>
        </article>
      `).join('');
      cartFooter.hidden = false;
      cartFooter.querySelector('[data-cart-total]').textContent = money(cart.total_price);
    }

    drawer.querySelectorAll('[data-shipping-goal]').forEach((goal) => {
      const target = Number(goal.dataset.goal);
      const remaining = Math.max(0, target - cart.total_price);
      const progress = Math.min(100, (cart.total_price / target) * 100);
      const isGift = target >= 40000;
      goal.querySelector('[data-goal-progress]').style.width = `${progress}%`;
      goal.querySelector('[data-goal-message]').textContent = remaining > 0
        ? `${isGift ? 'Add' : 'Spend'} ${money(remaining)} more for ${isGift ? 'a free pumice stone' : 'free delivery'}`
        : `${isGift ? 'Free pumice stone' : 'Free delivery'} unlocked ✓`;
    });
  }

  async function refreshCart() {
    try {
      const response = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('Unable to load cart');
      renderCart(await response.json());
    } catch (error) {
      console.error(error);
    }
  }

  async function addItems(items) {
    const response = await fetch(`${root}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items }),
    });
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || 'This item could not be added.');
    await refreshCart();
    openCart();
    return data;
  }

  async function changeItem(key, quantity) {
    const response = await fetch(`${root}cart/change.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity }),
    });
    if (!response.ok) throw new Error('Unable to update cart');
    renderCart(await response.json());
  }

  function initCountdown(scope = document) {
    scope.querySelectorAll('[data-countdown-root]:not([data-initialized])').forEach((widget) => {
      widget.dataset.initialized = 'true';
      const output = widget.querySelector('[data-countdown]');
      if (!output) return;
      const duration = Math.max(3600, Number(widget.dataset.countdownSeconds || 28800));
      const key = 'heyxi-sale-deadline';
      let deadline = Number(sessionStorage.getItem(key));
      if (!deadline || deadline <= Date.now()) {
        deadline = Date.now() + duration * 1000;
        sessionStorage.setItem(key, String(deadline));
      }
      const tick = () => {
        let left = Math.max(0, Math.floor((deadline - Date.now()) / 1000));
        if (!left) {
          deadline = Date.now() + duration * 1000;
          sessionStorage.setItem(key, String(deadline));
          left = duration;
        }
        const hours = String(Math.floor(left / 3600)).padStart(2, '0');
        const minutes = String(Math.floor((left % 3600) / 60)).padStart(2, '0');
        const seconds = String(left % 60).padStart(2, '0');
        output.textContent = `${hours}:${minutes}:${seconds}`;
      };
      tick();
      window.setInterval(tick, 1000);
    });
  }

  function initProduct(scope = document) {
    scope.querySelectorAll('[data-product-section]:not([data-initialized])').forEach((section) => {
      section.dataset.initialized = 'true';
      const images = [...section.querySelectorAll('[data-gallery-image]')];
      const thumbs = [...section.querySelectorAll('[data-gallery-thumb]')];
      let active = 0;

      const showImage = (index) => {
        if (!images.length) return;
        active = (index + images.length) % images.length;
        images.forEach((image, imageIndex) => image.classList.toggle('is-active', imageIndex === active));
        thumbs.forEach((thumb, thumbIndex) => {
          thumb.classList.toggle('is-active', thumbIndex === active);
          thumb.setAttribute('aria-selected', String(thumbIndex === active));
        });
      };
      showImage(0);
      thumbs.forEach((thumb) => thumb.addEventListener('click', () => showImage(Number(thumb.dataset.index))));
      section.querySelector('[data-gallery-prev]')?.addEventListener('click', () => showImage(active - 1));
      section.querySelector('[data-gallery-next]')?.addEventListener('click', () => showImage(active + 1));

      const updateVariant = (radio) => {
        section.querySelectorAll('[data-bundle-card]').forEach((card) => card.classList.toggle('is-selected', card.contains(radio)));
        section.querySelector('[data-selected-price]').textContent = radio.dataset.priceFormatted;
        const compare = section.querySelector('[data-selected-compare]');
        const saving = section.querySelector('[data-selected-saving]');
        const hasSaving = Number(radio.dataset.compare) > Number(radio.dataset.price);
        compare.hidden = !hasSaving;
        saving.hidden = !hasSaving;
        if (hasSaving) {
          compare.textContent = radio.dataset.compareFormatted;
          saving.textContent = `SAVE ${radio.dataset.savingFormatted}`;
        }
        section.querySelector('[data-installment]').textContent = money(Number(radio.dataset.price) / 4);
        section.querySelector('[data-mobile-price]').textContent = radio.dataset.priceFormatted;
        section.querySelector('[data-mobile-title]').textContent = radio.dataset.title;
        const button = section.querySelector('[data-add-button]');
        const available = radio.dataset.available === 'true';
        button.disabled = !available;
        button.querySelector('[data-add-label]').textContent = available ? 'Claim offer & add to cart' : 'Sold out';
      };
      section.querySelectorAll('[data-variant-radio]').forEach((radio) => radio.addEventListener('change', () => updateVariant(radio)));

      const form = section.querySelector('[data-product-form]');
      form?.addEventListener('submit', async (event) => {
        event.preventDefault();
        const selected = form.querySelector('[data-variant-radio]:checked');
        const button = form.querySelector('[data-add-button]');
        if (!selected || button.disabled) return;
        const label = button.querySelector('[data-add-label]');
        const original = label.textContent;
        button.disabled = true;
        label.textContent = 'Adding…';
        const items = [{ id: Number(selected.value), quantity: 1 }];
        const bump = form.querySelector('[data-order-bump]:checked');
        if (bump) items.push({ id: Number(bump.dataset.variantId), quantity: 1 });
        try {
          await addItems(items);
          label.textContent = 'Added ✓';
        } catch (error) {
          label.textContent = error.message;
        } finally {
          window.setTimeout(() => {
            button.disabled = selected.dataset.available !== 'true';
            label.textContent = original;
          }, 1600);
        }
      });

      section.querySelector('[data-mobile-submit]')?.addEventListener('click', () => form?.requestSubmit());
      section.querySelectorAll('[data-quick-add]').forEach((button) => button.addEventListener('click', async () => {
        const original = button.innerHTML;
        button.disabled = true;
        button.textContent = 'Adding…';
        try { await addItems([{ id: Number(button.dataset.quickAdd), quantity: 1 }]); }
        catch (error) { window.alert(error.message); }
        finally { button.disabled = false; button.innerHTML = original; }
      }));
    });
  }

  function initBeforeAfter(scope = document) {
    scope.querySelectorAll('[data-before-after]:not([data-initialized])').forEach((slider) => {
      slider.dataset.initialized = 'true';
      const range = slider.querySelector('[data-before-after-range]');
      const beforeImage = slider.querySelector('.before-after__image--before');
      if (!range) return;
      const update = () => {
        slider.style.setProperty('--position', `${range.value}%`);
        if (beforeImage) beforeImage.style.width = `${slider.clientWidth}px`;
      };
      range.addEventListener('input', update);
      window.addEventListener('resize', update, { passive: true });
      update();
    });
  }

  function initReviews(scope = document) {
    scope.querySelectorAll('[data-reviews]:not([data-initialized])').forEach((reviews) => {
      reviews.dataset.initialized = 'true';
      const cards = [...reviews.querySelectorAll('[data-review-card]')];
      reviews.querySelectorAll('[data-review-filter]').forEach((button) => button.addEventListener('click', () => {
        reviews.querySelectorAll('[data-review-filter]').forEach((tab) => tab.classList.toggle('is-active', tab === button));
        const filter = button.dataset.reviewFilter;
        cards.forEach((card) => { card.hidden = filter === 'media' && card.dataset.media !== 'true'; });
      }));
    });
  }

  function initUgc(scope = document) {
    scope.querySelectorAll('[data-ugc-card]:not([data-initialized])').forEach((card) => {
      card.dataset.initialized = 'true';
      const play = card.querySelector('[data-ugc-play]');
      const sound = card.querySelector('[data-ugc-sound]');
      const bar = card.querySelector('[data-ugc-progress]');
      let playing = false;
      let muted = true;
      let progress = 0;
      let timer;
      play?.addEventListener('click', () => {
        playing = !playing;
        card.classList.toggle('is-playing', playing);
        play.textContent = playing ? '❚❚' : '▶';
        play.setAttribute('aria-label', playing ? 'Pause demo' : 'Play demo');
        window.clearInterval(timer);
        if (playing) timer = window.setInterval(() => {
          progress = progress >= 100 ? 0 : progress + 1;
          bar.style.width = `${progress}%`;
        }, 120);
      });
      sound?.addEventListener('click', () => {
        muted = !muted;
        sound.textContent = muted ? '⌁' : '◖))';
        sound.setAttribute('aria-label', muted ? 'Turn sound on' : 'Mute sound');
      });
    });
  }

  function initAll(scope = document) {
    initCountdown(scope);
    initProduct(scope);
    initBeforeAfter(scope);
    initReviews(scope);
    initUgc(scope);
  }

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-cart-open]')) openCart();
    if (event.target.closest('[data-cart-close]')) closeCart();
    const change = event.target.closest('[data-cart-change]');
    if (change) changeItem(change.dataset.cartChange, Number(change.dataset.quantity)).catch(console.error);
  });
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape') closeCart(); });
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  initAll();
  refreshCart();
})();
